// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const openNewTab = (event: any, url: string): void => {
  event.preventDefault();
  const newTab = window.open(url, '_blank', 'noopener,noreferrer');
  if (newTab) newTab.opener = null;
};
